import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux'
import { setNoteText } from '../redux/FeedbackRedux';
import { ajaxDeleteNumber } from 'libphonenumber-js';


class EditNote extends React.Component {
    handleChange(event) {
        var text = event.target.value;
        this.props.dispatch(setNoteText(text));
    }

	render () {
		return (
        <div className="row">
                <div className="col-md-3">
                    <h5>{ __('Author') }:</h5>
                </div>
                <div className="col-md-9">
                    {this.props.note.user &&
                        <span className="text-muted">{this.props.note.user.firstname?this.props.note.user.firstname+" "+this.props.note.user.firstname:"Anonymous"}</span>
                    }
                    {
                        <span className="text-muted">{this.props.note.user_name}</span>
                    }

                </div>

                <div className="col-md-3">
                    <h5>{ __('Date') }:</h5>
                </div>
                <div className="col-md-9">
                    <span className="text-muted">{this.props.note.created_at}</span>
                </div>

                <div className="col-md-12 mt-3">
                        <div className="input-group feedback-form-control mb-0 border">
                            <div className="input-group-prepend prepend-textarea">
                                <span className="input-group-text"><i className="fas fa-edit"></i></span>
                            </div>
                            <textarea className="form-control textarea pl-0" value={this.props.text} onChange={this.handleChange.bind(this)} placeholder="{ __('Edit this note') }..." aria-label="{ __('Edit this note') }...">{this.props.note.note}</textarea>
                        </div>
                </div>
        </div>
        );
	}
}

function mapStateToProps(state) {
	return { note:state.selected_note.note, text: state.selected_note_text }
}

export default connect(mapStateToProps)(EditNote)
